import { ReactElement } from 'react';

import { Box, Typography } from '@mui/material';
import LoadingSpinner from '../../../../common/components/molecules/LoadingSpinner';
import { useExecutiveReportsQuery } from '../../../../common/hooks/backend';
import FreeTrialForAccessDialog from '../../../../common/modules/purchase/components/dialogs/FreeTrialForAccessDialog';
import PurchaseForAccessDialog from '../../../../common/modules/purchase/components/dialogs/PurchaseForAccessDialog';
import { ModuleKey } from '../../../../common/modules/purchase/enums/moduleKey';
import ReportCard from '../molecules/ReportCard';

export interface ExecutivePageProps {
  hasAccess: boolean;
  isFreeTrial: boolean;
}

export default function ExecutiveHomePage(props: ExecutivePageProps): ReactElement {
  const { hasAccess, isFreeTrial } = props;

  const { data: reports, isLoading } = useExecutiveReportsQuery();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      {!hasAccess && (
        <>
          <FreeTrialForAccessDialog moduleKey={ModuleKey.Executive} />
          <PurchaseForAccessDialog moduleKey={ModuleKey.Executive} />
        </>
      )}
      <Typography display="flex" variant="h5" color="primary" ml={3}>
        ANNUAL
      </Typography>
      <Box display="flex" flexWrap="wrap">
        {reports
          ?.filter((r) => r.reportType === 'Annual')
          .map((report) => (
            <ReportCard key={report.reportId} report={report} hasAccess={hasAccess} isFreeTrial={isFreeTrial} />
          ))}
      </Box>
      <Typography display="flex" variant="h5" color="primary" ml={3} mt={3}>
        MONTHLY
      </Typography>
      <Box display="flex" flexWrap="wrap">
        {reports
          ?.filter((r) => r.reportType === 'Monthly')
          .map((report) => (
            <ReportCard key={report.reportId} report={report} hasAccess={hasAccess} isFreeTrial={isFreeTrial} />
          ))}
      </Box>
    </>
  );
}
